import { useState, useEffect } from 'react';
import isMobile from 'ismobilejs';

export default function useWindowDimensions(isSetMobile = false) {

  const hasWindow = typeof window !== 'undefined';

  function getWindowDimensions() {
    const mobile = !isSetMobile ? isMobile(window.navigator).any : true;
    const innerWidth:any = hasWindow && mobile ? window.innerWidth : null;
    const innerHeight:any = hasWindow && mobile ? window.innerHeight : null;
    return {
      innerWidth,
      innerHeight,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  useEffect(() => {
    if (hasWindow) {
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow]);

  return windowDimensions;
}